import service from '@/service'

// 批量对接成功-失败
export function batchDock(data) {
  return service['api-scm']({
    url: '/dc/updateDockStatus/batchDock',
    method: 'post',
    data
  })
}

// 查询列表
export function getList(data) {
  return service['api-scm']({
    url: '/dc/updateDockStatus/getList',
    method: 'post',
    data
  })
}
